import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import { ReactNode } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';
import LocalizedLink from '../LocalizedLink';

export interface ProposalCardProps {
  icon?: string | { url: string; alt: string };
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  link?: string;
  color?: 'violet' | 'green' | 'blue';
}
function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

export default function ProposalCard({
  title,
  subtitle,
  icon,
  link,
  color = 'green',
}: ProposalCardProps) {
  const iconLink = icon && typeof icon === 'object' ? icon.url : icon;
  const iconAlt = icon && typeof icon === 'object' ? icon.alt : '';

  const backgroundColorClass =
    {
      green: 'custom-gradient-green-btn-h',
      blue: 'custom-gradient-blue-btn-h',
      violet: 'custom-gradient-violet-btn-h',
    }[color] || 'custom-gradient-green-btn-h';
  return (
    <div
      data-meta="ProposalCard"
      className={`flex p-4 xl:p-8 gap-12 backdrop-blur-sm bg-white/30 rounded-3xl ${
        iconLink ? '' : 'justify-between'
      }`}
    >
      <div className={`flex items-start justify-center text-white ${iconLink ? '' : 'order-2'}`}>
        {iconLink && (
          <div className="flex justify-center items-center backdrop-blur-sm bg-white/30 rounded-full h-16 w-16">
            <Image src={iconLink} width={32} height={32} alt={iconAlt} />
          </div>
        )}
        {link && (
          <LocalizedLink
            className={`${backgroundColorClass} uppercase flex justify-center items-center rounded-full border hover:border-0 border-white h-16 w-16`}
            href={link}
          >
            <ArrowUpRightIcon className="text-white h-6 w-6" />
          </LocalizedLink>
        )}
      </div>
      <div
        className={classNames(
          icon ? '' : 'order-1 justify-start',
          subtitle ? 'lg:items-start' : 'lg:items-center',
          'text-white flex flex-col justify-center',
        )}
      >
        <CustomRichText
          data={title}
          tag="div"
          className={classNames(subtitle ? 'md:mb-6' : '', 'text-xl font-bold')}
        />

        {subtitle && <CustomRichText data={subtitle} tag="div" className="md:block" />}
      </div>
    </div>
  );
}
